export default __webpack_public_path__ + "static/media/setempty.d7eee50a.svg";